export default "__VITE_ASSET__a0928719__"